<template>
  <div id="wrapper">
    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Cliente' btnLink='$back' btnTxt='Voltar'
        :action="isEdit ? `Editar ${company.fantasy}` : 'Nova'"/>

      <div class="wrapper wrapper-content animated fadeIn">

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <div class="row">
          <div class="col-lg-12">
            <div class="ibox float-e-margins">

              <div class="ibox-title">
                <h5> Cadastro de Cliente <small class="required-advice"/></h5>

                <div v-if="isEdit">

                  <label class="radio-inline">
                    <input type="radio" value="1" v-model="company.status" :disabled="readonly">
                    <span class="label label-primary">Ativa</span>
                  </label>

                  <label class="radio-inline">
                    <input type="radio" value="2" v-model="company.status" :disabled="readonly">
                    <span class="label label-warning">Pendente</span>
                  </label>

                  <label class="radio-inline">
                    <input type="radio" value="0" v-model="company.status" :disabled="readonly">
                    <span class="label label-default">Inativa</span>
                  </label>

                </div>

              </div>

              <div class="ibox-content">
                <form role="form" autocomplete="off">
                <div class="row">
                  <div class="col-sm-6 b-r">

                    <div class="form-group">

                      <label class="col-sm-2 control-label">Tipo Pessoa</label>

                      <div class="radio-group">
                        <div class="radio i-checks"><label> <input type="radio" value="0" v-model="company.type" :disabled="isEdit || readonly"> <i></i> Pessoa Jurídica </label></div>
                        <div class="radio i-checks"><label> <input type="radio" value="1" v-model="company.type" :disabled="isEdit || readonly"> <i></i> Pessoa Física </label></div>
                      </div>

                    </div>

                    <div class="hr-line-dashed"></div>

                    <div class="form-group required" v-if='company.type == 0'>
                      <label for="CNPJ" class="control-label" :class="{invalid: errors.has('CNPJ')}"> CNPJ </label>
                      <input type="text" name="CNPJ" class="form-control" placeholder="Somente os números"
                        v-mask="'99.999.999/9999-99'" @blur="getCompanyData(company.document)" v-model="company.document"
                        v-validate="'required|cnpj'" data-vv-validate-on="blur" :class="{ invalid: errors.has('CNPJ') }" :disabled="isEdit || readonly">
                      <span class="error">{{ errors.first('CNPJ') }}</span>
                    </div>

                    <div class="form-group required" v-if='company.type == 1'>
                      <label for="CPF" class="control-label" :class="{invalid: errors.has('CPF')}"> CPF </label>
                      <input type="text" name="CPF" class="form-control" placeholder="Somente os números"
                      v-mask="'999.999.999-99'" v-model="company.document"
                      v-validate="'required|min:14|max:14'" data-vv-validate-on="blur" :class="{ invalid: errors.has('CPF') }" :disabled="isEdit || readonly">
                      <span class="error">{{ errors.first('CPF') }}</span>
                    </div>

                    <div class="hr-line-dashed"></div>

                    <div class="form-group required">
                      <label for="name" class="control-label" >
                        <span :class="{invalid: errors.has('name')}" v-if="company.type == '0'"> Razão Social </span>
                        <span :class="{invalid: errors.has('name')}" v-if="company.type == '1'"> Nome </span>
                      </label>
                      <input type="text" class="form-control" name="name" placeholder="Nome" :disabled="readonly"
                      autocomplete="off" v-model="company.name" v-validate="'required|min:4'" :class="{invalid: errors.has('name')}">
                      <span class="error">{{ errors.first('name') }}</span>
                    </div>

                    <div class="form-group" v-if="company.type == '0'">
                      <label for="fantasy" class="control-label" :class="{ invalid: errors.has('fantasy')}"> Nome Fantasia </label>
                      <input type="text" class="form-control" name="fantasy" placeholder="Nome Fantasia" autocomplete="off"
                      v-model="company.fantasy" v-validate="'min:2'" :class="{invalid: errors.has('fantasy')}" :disabled="readonly">
                      <span class="error">{{ errors.first('fantasy') }}</span>
                    </div>

                    <div class="form-group required">
                      <label for="Telefone" class="control-label" :class="{ invalid: errors.has('Telefone')}"> Telefone </label>
                      <input type="text" name="Telefone" class="form-control" placeholder="Somente os números" :disabled="readonly"
                      autocomplete="off" v-model="company.phone" v-validate="'required'" :class="{invalid: errors.has('Telefone')}">
                      <span class="error">{{ errors.first('Telefone') }}</span>
                    </div>

                    <div class="form-group" v-if='company.type == 0'>

                      <div class="col-sm-12">

                        <div class="row">

                          <div class="col-md-6 adjust-right">
                            <label class="control-label" for="ie"> Inscrição Estadual </label>
                            <input type="text" name="ie" class="form-control" placeholder="Somente números" v-model="company.ie" :disabled="readonly">
                          </div>

                          <div class="col-md-6 adjust-left">
                            <label class="control-label" for="im"> Inscrição Municipal </label>
                            <input type="text" name="im" class="form-control" placeholder="Somente números" v-model="company.im" :disabled="readonly">
                          </div>

                        </div>

                      </div>
                    </div>

                  </div>

                  <div class="col-sm-6">

                    <div class="form-group required" v-if="company.type == '0'">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-md-6 adjust-right">
                            <label class="control-label" for="contato" :class="{ invalid: errors.has('contato')}"> Responsável </label>
                            <input type="text" name="contato" class="form-control" placeholder="Nome completo" :disabled="readonly"
                            v-model="company.contact" v-validate="'required|alpha_spaces|min:4|max:100'" :class="{invalid: errors.has('contato')}">
                            <span class="error">{{ errors.first('contato') }}</span>
                          </div>

                          <div class="col-md-6 adjust-left">
                            <label class="control-label" for="telefone" :class="{ invalid: errors.has('telefone')}"> Telefone </label>
                            <input type="text" name="telefone" class="form-control" placeholder="Somente os números" :disabled="readonly"
                            v-model="company.contact_phone" v-validate="'required'" :class="{invalid: errors.has('telefone')}">
                            <span class="error">{{ errors.first('telefone') }}</span>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="form-group required">
                      <input-tag name="Emails" type="email" v-model="emails" :blocked="readonly"
                        v-validate="'required|email'" :error="errors.first(`Emails`)">
                      </input-tag>
                    </div>

                    <div class="hr-line-dashed"></div>

                    <h4> Endereço </h4>

                    <div class="form-group">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-md-6 adjust-right">
                            <label class="control-label" for="cpf"> CEP </label>
                            <input type="text" name="cep" class="form-control" placeholder="digite somente os números"
                            v-mask="'99.999-999'" v-model="company.cep" @blur="getAddress(company.cep)" :disabled="readonly">
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-md-10 adjust-right">
                            <label class="control-label" for="place"> Logradouro </label>
                            <input type="text" name="place" class="form-control" v-model="company.place" :disabled="readonly">
                          </div>
                          <div class="col-md-2 adjust-left">
                            <label class="control-label" for="cpf"> Número </label>
                            <input type="text" name="number" class="form-control" placeholder="S/N" v-model="company.number" :disabled="readonly">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label" for="complemento" :class="{ invalid: errors.has('complemento')}">Complemento</label>
                      <input type="text" name="complemento" class="form-control" v-validate="'max:255'" v-model="company.complement"
                      :class="{ invalid: errors.has('complemento')}" :disabled="readonly">
                      <span class="error">{{ errors.first('complemento') }}</span>
                    </div>

                    <div class="form-group required">

                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-md-5 adjust-right">
                            <label for="neighborhood"> Bairro </label>
                            <input type="text" name="neighborhood" class="form-control" v-model="company.neighborhood" :disabled="readonly">
                          </div>

                          <div class="col-md-5 adjust-right">
                            <label class="control-label" for="cidade" :class="{ invalid: errors.has('cidade')}"> Cidade </label>
                            <input type="text" name="cidade" class="form-control" v-model="company.city" :disabled="readonly"
                            v-validate="'required|min:3'" :class="{invalid: errors.has('cidade')}">
                          </div>

                          <div class="col-md-2 adjust-left">
                            <label class="control-label" for="UF" :class="{ invalid: errors.has('UF')}"> Estado </label>
                            <select class="form-control" name="UF" v-model="company.state" :disabled="readonly"
                            v-validate="'required|is_not:UF'" :class="{invalid: errors.has('UF')}">
                              <option v-for="uf in states" v-bind:key="uf">{{uf}}</option>
                            </select>
                          </div>
                        </div>

                        <span class="error">{{ errors.first('cidade') }}</span>
                        <span class="error">{{ errors.first('UF') }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="tags"> Tags </label>
                  <multiselect v-model="company.tags" id="tags" :class="{ loading: loadingTags }"
                    placeholder="Busque ou crie uma tag"
                    tag-placeholder="Clique ou aperte ENTER para criar e adicionar a tag"
                    selected-label=""
                    deselect-label=""
                    :disabled="readonly"
                    :options="filteredTags"
                    :custom-label="option => option.value"
                    track-by="value"
                    :internal-search="false"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :local-search="false"
                    :multiple="true"
                    :searchable="true"
                    :hide-selected="true"
                    :loading="loadingTags"
                    :taggable="true"
                    @search-change="onSearchTags"
                    @tag="onTag">

                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="label label-success">
                        {{ option.value }}
                        <button @click="remove(option)" type="button" class="btn btn-link"><i class="fa fa-close"/></button>
                      </span>
                    </template>

                    <span slot="noResult">Não houve resultados na busca</span>
                  </multiselect>
                </div>

                <div class="ibox-content no-border cnaes">
                  <div class="row">
                    <div class="form-group">
                      <label class="multiselect__input" for="activities"> CNAE </label>
                      <multiselect v-model="company.activities" id="activities"
                        placeholder=" busca CNAE ou descrição"
                        :options="cnaes"
                        :custom-label="codeWithdesc"
                        track-by="code"
                        :disabled="readonly"
                        :options-limit="1329"
                        :internal-search="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :local-search="false"
                        :multiple="true"
                        :searchable="true"
                        :hide-selected="true"
                        open-direction="top"
                        :showLabels="false"
                        @search-change="onSearch">

                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="label label-success">
                            {{ option.code | cnaeFilter}} - {{ option.description }}
                            <button @click="remove(option)" type="button" class="btn btn-link"><i class="fa fa-close"/></button>
                          </span>
                        </template>

                        <span slot="noResult">Não houve resultados na busca</span>
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <button class="btn btn-w-m btn-success pull-right" v-if="!isEdit"
                      @click.prevent="saveNewCompany(company)" :disabled="disable">
                      <i class="fa fa-save"></i> Salvar
                    </button>

                    <div class="edit-painel" v-if="isEdit">

                      <button class="btn btn-w-m btn-danger pull-right" data-toggle="modal"
                        data-target="#deleteModal" :disabled="disable || readonly" @click.prevent>
                        <i class="fa fa-trash"></i> Excluir
                      </button>

                      <button class="btn btn-w-m btn-success pull-right" v-if="isEdit"
                        @click.prevent="editCompany(company)" :disabled="disable || readonly">
                        <i class="fa fa-save"></i> Salvar
                      </button>

                      <!--  ============================== MODAL DE EXCLUSÃO DE EMPRESA ============================= -->
                      <div class="modal inmodal fade" id="deleteModal" tabindex="-1" role="dialog"  aria-hidden="true">
                        <div class="modal-dialog">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button type="button" class="close" data-dismiss="modal">
                                <span aria-hidden="true">&times;</span>
                                <span class="sr-only">Close</span>
                              </button>
                              <i class="fa fa-trash modal-icon"></i>
                              <h4 class="modal-title">Atenção!</h4>
                            </div>
                            <div class="modal-body">
                              <p>
                                Ao excluir o cliente <strong>{{ company.name }}</strong>
                                todos os dados serão <strong>PERDIDOS DEFINITIVAMENTE</strong>, deseja realmente prosseguir?
                              </p>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-w-m btn-white" data-dismiss="modal"> Cancelar </button>

                              <button type="button" class="btn btn-w-m btn-danger" data-dismiss="modal"
                                @click.prevent="deleteCompany(company)">Exclui
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>

              </form>
              </div>

            </div>
          </div>
        </div>

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'
  import Spinner from './layout/Spinner'
  import InputTag from './InputTag'
  import Multiselect from 'vue-multiselect'
  import ConfirmDeleteBtn from "./layout/ConfirmDeleteBtn"
  import Help from './Help'

  import _ from 'lodash'

  import { httpService } from '../providers/http-service'
  import { helper } from '../mixins/helper'
  import { toast } from '../mixins/toast'
  import { errorMessage } from '../mixins/error-message'
  import { permissions } from '../mixins/permissions'
  import { mapGetters } from 'vuex'

  import cnaesJson from '../assets/cnaes.json'

  export default {
    mixins: [ helper, toast, permissions, errorMessage ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, Spinner, Multiselect, InputTag, ConfirmDeleteBtn , Help},
    data () {
      return {
        showSpinner: false,
        disable: false,
        isEdit: false,
        readonly: false,
        setAdmin: false,
        cnaes: [],
        emails: [],
        company: {
          status: '1',
          type: '0',
          state: 'UF',
          activities: [],
          tags: []
        },
        states:[
          'UF','AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
          'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'
        ],
        availableProducts: [],

        //Tags
        loadingTags: false,
        tagList: [],
        filteredTags: []
      }
    },

    methods: {
      ...mapGetters(['getCompany', 'getLoggedUser']),

      saveNewCompany(company) {
        this.disable = true
        this.$validator.validateAll().then(valid => {
          if(valid) {
            company.email = this.emails.join()
            this.showSpinner = true
            this.dataHandler(company).then(cmp => {
              // Cria a empresa
              return httpService.saveNewCompany(cmp)
            }).then((res) => {
              // Associa os produtos à empresa criada.
              this.company.public_key = res.data[0].public_key
              return this.associateProducts(this.company.public_key)
            }).then(() => {
              // Tudo bem sucedido
              this.disable = false
              this.showSpinner = false
              this.show_toast('success', 'OK', 'Cliente cadastrado com sucesso!')
              this.resetForm()
            }).catch((err) => { this.showErrorMessage({ err: err }) })
          } else {
            this.disable = false
            this.showSpinner = false
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
            this.$validator.validateAll()
          }
        })
      },

      editCompany(company) {
        this.checkPermissions(company.id, '5bc919ca057f99025eabfda5818b9741', 'alterar este cliente')
        .then((isPermited) => {
          if(isPermited){
            company.email = this.emails.join()
            this.disable = true
            this.$validator.validateAll().then((valid) => {
              if(valid) {
                this.showSpinner = true
                this.dataHandler(company)
                .then((cmp) => {
                  // Edita a empresa
                  return httpService.editCompany(cmp)
                })
                .then(() => {
                  // Tudo bem sucedido
                  this.resetForm()
                  this.$router.push({ path: '/company'})
                  this.disable = false
                  this.showSpinner = false
                  this.show_toast('success', 'OK', 'Cliente alterado com sucesso!')
                })
                .catch((err) => { this.showErrorMessage({ err: err }) })
              } else {
                this.disable = false
                this.showSpinner = false
                this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
                this.$validator.validateAll()
              }
            })
          }
        })
      },

      deleteCompany(cmp) {
        this.checkPermissions(cmp.id, 'b0151a967f25aac481c7ea315366e9f1', 'excluir este cliente')
        .then((isPermited) => {
          if(isPermited) {
            this.disable = true
            this.showSpinner = true
            httpService.deleteCompany(cmp.id).then((res) => {
              if(res.status === 200) {
                this.disable = false
                this.showSpinner = false
                this.$router.push({ path: '/company'})
                this.show_toast('success', 'OK', 'Cliente excluído com sucesso!')
              }
            }).catch((err) => {
              this.disable = false
              this.showSpinner = false
              this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
            })
          }
        })
      },

      associateProducts(companyID) {
        return Promise.all(this.availableProducts.map(prod => {
          httpService.setCompanyProduct(prod, companyID)
            .catch(err => this.showErrorMessage({ err: err }))
        }))
      },

      onSearch(query) {
        this.cnaes = cnaesJson.filter((el) => {
          return el.code.match(query) || el.description.toLowerCase().match(query.toLowerCase())
        })
      },

      codeWithdesc({code, description }) {
        if(code && description) {
          return `${code.substr(0, 4)}-${code.substr(4, 1)}/${code.substr(5, 2)} : ${description}`
        }
      },

      getTags() {
        httpService.getCompanyTagList().then(res => {
          this.tagList = res.data
          this.filteredTags = this.tagList
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      onSearchTags(search) {
        if(!search) { return }
        this.loadingTags = true
        this.filteredTags = this.tagList.filter(tag => tag.value.match(new RegExp(search, 'i')))
        this.loadingTags = false
      },

      onTag(text) {
        const tag = { value:  text.replace(/[^\w\s\d]/gi, '').toUpperCase() }
        let exists = false
        this.company.tags.forEach(t => { if(tag.value === t.value) exists = true })
        if(!exists) {
          this.tagList.push(tag)
          this.company.tags.push(tag)
        }
      },

      getCompanyProducts() {
        const masterCompanyID = this.getCompany().public_key
        if(masterCompanyID === '944b1b76411de44f9c81aecd23a8499f') {
          this.availableProducts = ['d300660e4320d8d5c8ecb48035b67815']
        } else {
          httpService.getCompanyProducts(masterCompanyID).then(res => {
            this.availableProducts = res.data.map(prod => prod.product_public_key)
          }).catch(err => this.showErrorMessage({ err: err }))
        }
      }

    },

    mounted() {
      this.cnaes = cnaesJson
      this.getCompanyProducts()
      this.getTags()
      if(Object.keys(this.$route.query).length !== 0) {
        this.isEdit = true
        this.populateFields(this.$route.query)
        if(this.$route.query.public_key === this.getCompany().public_key) { this.readonly = true }
      }
    }
  }
</script>

<style scoped>
  .label small { margin: 2px 5px; }
  .radio-group div:last-child { padding-left: 16.5%; }

  div .adjust-right {
    padding-left: 1px;
    padding-bottom: 14px;
  }

  input.uf { text-transform: uppercase; }

  div .adjust-left { padding-right: 1px; }

  .edit-painel button { margin: 4px; }

  label.radio-inline { margin-left: 20px; }

  label.radio-inline span { font-weight: bolder; }

  .modal-body p { text-align: center; font-size: 16px; }
  .modal-body { background-color: inherit; }
  div.cnaes { padding: 5px 15px 5px 15px; }

  .no-border { border-style: initial }

  .tool-tip {
  	color: #fff;
  	background-color: rgba( 0, 0, 0, .7);
  	visibility: hidden;
  	-webkit-border-radius: 7px;
  	-moz-border-radius: 7px;
  	-o-border-radius: 7px;
  	border-radius: 7px;
  	text-align: center;
  	opacity: 0;
  	z-index: 999;
  	padding: 3px 8px;
  	position: absolute;
  	-webkit-transition: all 240ms ease-in-out;
  	-moz-transition: all 240ms ease-in-out;
  	-ms-transition: all 240ms ease-in-out;
  	-o-transition: all 240ms ease-in-out;
  	transition: all 240ms ease-in-out;
  }

  .tool-tip, .tool-tip.top {
  	top: auto;
  	bottom: 114%;
  	left: 50%;
  }

  .tool-tip.top:after,
  .tool-tip:after {
  	position: absolute;
  	bottom: -12px;
  	left: 50%;
  	margin-left: -7px;
  	content: ' ';
  	height: 0px;
  	width: 0px;
  	border: 6px solid transparent;
    border-top-color: rgba( 0, 0, 0, .7);
  }

  .tool-tip, .tool-tip.top{
  	width: 280px;
  	height: auto;
  	margin-left: -43px;
  }

  *:not(.on-focus):hover > .tool-tip,
  .on-focus input:focus + .tool-tip{
  	visibility: visible;
  	opacity: 1;
  	-webkit-transition: all 240ms ease-in-out;
  	-moz-transition: all 240ms ease-in-out;
  	-ms-transition: all 240ms ease-in-out;
  	-o-transition: all 240ms ease-in-out;
  	transition: all 240ms ease-in-out;
  }

  /* tooltip slide out */
  *:not(.on-focus) > .tool-tip.slideIn,
  .on-focus > .tool-tip{ display: block; }

  .on-focus > .tool-tip.slideIn{ z-index: -1; }

  .on-focus > input:focus + .tool-tip.slideIn{ z-index: 1; }

  /* top slideIn */
  *:not(.on-focus) > .tool-tip.slideIn,
  *:not(.on-focus) > .tool-tip.slideIn.top,
  .on-focus > .tool-tip.slideIn,
  .on-focus > .tool-tip.slideIn.top{ bottom: 50%; }

  *:not(.on-focus):hover > .tool-tip.slideIn,
  *:not(.on-focus):hover > .tool-tip.slideIn.top,
  .on-focus > input:focus + .tool-tip.slideIn,
  .on-focus > input:focus + .tool-tip.slideIn.top{ bottom: 110%; }

  .right { text-align: right; }

  .checkbox-group { padding-top: 30px; }
</style>



// WEBPACK FOOTER //
// src/components/CompanyCreatePage.vue